import { OnInit } from '@angular/core';
import { resolveThemeCssClass } from '../lib/helper/panel-settings';
var HeroPanelComponent = /** @class */ (function () {
    function HeroPanelComponent() {
    }
    Object.defineProperty(HeroPanelComponent.prototype, "hostClasses", {
        get: function () { return resolveThemeCssClass(this.data.panelSettings); },
        enumerable: true,
        configurable: true
    });
    HeroPanelComponent.prototype.ngOnInit = function () {
        this.prepareMedia();
    };
    HeroPanelComponent.prototype.prepareMedia = function () {
        try {
            if (!this.data || !this.data.media || !this.data.media.value)
                return;
            var media = this.data.media.value;
            this.hasImage = !!media.image;
            if (this.hasImage) {
                this.media = media.image;
            }
            else {
                this.media = {
                    desktop: media.video.desktop || media.video.mobile,
                    mobile: media.video.mobile || media.video.desktop
                };
            }
        }
        catch (err) {
            console.error('TODO: fix it please');
        }
    };
    return HeroPanelComponent;
}());
export { HeroPanelComponent };
